const state = {
  token: '',
  customerId: '',
  userId: '',
  orderId: '',
  login: {},
  userInfo: {},
  orderInfo: {},
  bookInfo:{}
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js